import React from "react";
import "./Footer.module.css";

const Footer = () => {
  return (
    <div className="footer" id="footer">
      <div className="footerText footerLeft">
        © 2024 Schor Tax & Consulting
      </div>
      <div className="footerText footerRight">
        SchorTax@gmail.com
      </div>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js